export const orders = [
   {
    name: 'Orders',
    series: [
      {
        name: "1980",
        value: 21632
      }
    ]
  }
]

export const products = [
  {
    "name": "TEma 1",
    "value": 69400
  },
  {
    "name": "Product-2",
    "value": 59400
  },
  {
    "name": "Product-3",
    "value": 82400
  },
  {
    "name": "Product-4",
    "value": 73400
  },
  {
    "name": "Product-5",
    "value": 25400
  },
  {
    "name": "Product-6",
    "value": 23400
  },
  {
    "name": "Product-7",
    "value": 49300
  },
  {
    "name": "Product-8",
    "value": 55400
  },
  {
    "name": "Product-9",
    "value": 37400
  },
  {
    "name": "Product-10",
    "value": 65220
  },
  {
    "name": "Product-11",
    "value": 79400
  },
  {
    "name": "Product-12",
    "value": 58400
  },
  {
    "name": "Product-13",
    "value": 41400
  },
  {
    "name": "Product-14",
    "value": 37400
  },
  {
    "name": "Product-15",
    "value": 33700
  },
  {
    "name": "Product-16",
    "value": 42700
  },
  {
    "name": "Product-17",
    "value": 52700
  },
  {
    "name": "Product-18",
    "value": 62700
  }
]

export const customers = [
   {
    name: 'Customers',
    series: [
      {
        name: "2000",
        value: 34502
      }
    ]
  }
]

export const refunds = [
  {
    "name": "Item-1",
    "value": 23701
  },
  {
    "name": "Item-2",
    "value": 33701
  },
  {
    "name": "Item-3",
    "value": 63701
  },
  {
    "name": "Item-4",
    "value": 52701
  },
  {
    "name": "Item-5",
    "value": 73701
  },
  {
    "name": "Item-6",
    "value": 43701
  },
  {
    "name": "Item-7",
    "value": 83701
  },
  {
    "name": "Item-8",
    "value": 29701
  },
  {
    "name": "Item-9",
    "value": 69701
  },
  {
    "name": "Item-10",
    "value": 58701
  },
  {
    "name": "Item-11",
    "value": 65701
  },
  {
    "name": "Item-12",
    "value": 47701
  },
  {
    "name": "Item-13",
    "value": 41701
  },
  {
    "name": "Item-14",
    "value": 25701
  },
  {
    "name": "Item-15",
    "value": 35701
  }
]

export const disk_space = [
  {
    "name": "Tema 1",
    "value": 11
  },
  {
    "name": "Tema 2",
    "value": 35
  },
  {
    "name": "Tema 3",
    "value": 18
  },
  {
    "name": "Tema 4",
    "value": 2
  },
  {
    "name": "Tema 5",
    "value": 2
  },
  {
    "name": "Tema 6",
    "value": 31
  },
  {
    "name": "Tema 7",
    "value": 1
  }
]


export const analytics = [
  {
    name: '2019',
    series: [
      {
        name: 'Tema 1',
        value: 300
      },
      {
        name: 'Tema 2',
        value: 1050
      },
      {
        name: 'Tema 3',
        value: 510
      },
      {
        name: 'Tema 4',
        value: 70
      },
      {
        name: 'Tema 5',
        value: 50
      },
      {
        name: 'Tema 6',
        value: 920
      },
      {
        name: 'Tema 7',
        value: 20
      }
    ]
  },
  {
    name: '2020',
    series: [
      {
        name: 'Tema 1',
        value: 310
      },
      {
        name: 'Tema 2',
        value: 1060
      },
      {
        name: 'Tema 3',
        value: 500
      },
      {
        name: 'Tema 4',
        value: 60
      },
      {
        name: 'Tema 5',
        value: 60
      },
      {
        name: 'Tema 6',
        value: 900
      },
      {
        name: 'Tema 7',
        value: 20
      }
    ]
  },
  {
    name: '2021',
    series: [
      {
        name: 'Tema 1',
        value: 300
      },
      {
        name: 'Tema 2',
        value: 1050
      },
      {
        name: 'Tema 3',
        value: 510
      },
      {
        name: 'Tema 4',
        value: 70
      },
      {
        name: 'Tema 5',
        value: 50
      },
      {
        name: 'Tema 6',
        value: 910
      },
      {
        name: 'Tema 7',
        value: 10
      }
    ]
  },
  {
    name: '2022',
    series: [
      {
        name: 'Tema 1',
        value: 320
      },
      {
        name: 'Tema 2',
        value: 1070
      },
      {
        name: 'Tema 3',
        value: 540
      },
      {
        name: 'Tema 4',
        value: 70
      },
      {
        name: 'Tema 5',
        value: 60
      },
      {
        name: 'Tema 6',
        value: 920
      },
      {
        name: 'Tema 7',
        value: 20
      }
    ]
  },
]


// WEBPACK FOOTER //
// ./src/app/inicio/dashboard.data.ts